import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
import {MatMenuModule} from '@angular/material/menu';

import {MatDialogModule} from '@angular/material/dialog';


import {ManageTimeSessionComponent} from '@core/components/manage-time-session/manage-time-session.component';
import {CommonModule} from '@angular/common';

import { SharedSrvceCbModule } from '@core/services/shared/shared.module';
import { SymbolAlertModule } from '@core/components/symbol-alert';

@NgModule({
  declarations: [ManageTimeSessionComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    MatMenuModule,
    MatDialogModule,
    CommonModule,

    SharedSrvceCbModule,
    SymbolAlertModule
  ],
  exports: [ManageTimeSessionComponent]
})
export class ManageTimeSessionModule {}
